import fonts from './fonts';

const mixins = {
  flexColCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  flexRowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textH1: {
    fontFamily: fonts.primary,
    fontSize: 'clamp(5.2rem, 4vw, 9.6rem)',
    fontWeight: '700',
    lineHeight: '0.95em',
    letterSpacing: '-0.01em',
  },
  textH2: {
    fontFamily: fonts.primary,
    fontSize: 'clamp(3.6rem, 2vw, 4.8rem)',
    fontWeight: '700',
    lineHeight: '0.95em',
    letterSpacing: '0em',
  },
  textH3: {
    fontFamily: fonts.primary,
    fontSize: 'clamp(2.4rem, 1.5vw, 3.2rem)',
    fontWeight: '700',
    lineHeight: '0.95em',
    letterSpacing: '0em',
  },
  textH4: {
    fontFamily: fonts.primary,
    fontSize: 'clamp(2rem, 1.5vw, 2.4rem)',
    fontWeight: '700',
    lineHeight: '0.95em',
    letterSpacing: '0em',
  },
  textH5: {
    fontFamily: fonts.primary,
    fontSize: 'clamp(1.6rem, 1vw, 2rem)',
    fontWeight: '700',
    lineHeight: '0.95em',
    letterSpacing: '0em',
  },
  textP1: {
    fontFamily: fonts.secondary,
    fontSize: 'clamp(1.6rem, 1vw, 2.4rem)',
    fontWeight: ' ',
    lineHeight: '1.5em',
    letterSpacing: '0em',
  },
  textP2: {
    fontFamily: fonts.secondary,
    fontSize: 'clamp(1.4rem, 1vw, 2rem)',
    fontWeight: '500',
    lineHeight: '1.5em',
    letterSpacing: '0em',
  },
  textP3: {
    fontFamily: fonts.secondary,
    fontSize: 'clamp(1.4rem, 1vw, 1.6rem)',
    fontWeight: '400',
    lineHeight: '1.5em',
    letterSpacing: '0em',
  },
  textP4: {
    fontFamily: fonts.secondary,
    fontSize: 'clamp(1.2rem, 1vw, 1.4rem)',
    fontWeight: '400',
    lineHeight: '1.5em',
    letterSpacing: '0em',
  },
};
export default mixins;
